// CVVC's provider roster (Provider & Location Mapping sheet). All providers are vascular/
// interventional (no podiatry service line, unlike StrideCare) - referral-eligible-provider pools
// for diagnosis-based routing (e.g. GAE, plantar fasciitis) land in the workflow-steps phase.
type CvvcProviderRosterEntry = {
  name: string;
  athenaProviderId: string;
  credential: "MD" | "PA-C";
  // Athena department ID this provider is tied to, or null for providers who float across all
  // CVVC locations.
  departmentId: string | null;
};

export const CVVC_PROVIDERS = {
  ENGLISH: { name: "Sean J. English, MD", athenaProviderId: "161", credential: "MD", departmentId: "235" },
  FORTUNA: { name: "Gerald R. Fortuna, MD", athenaProviderId: "162", credential: "MD", departmentId: "234" },
  FRANZ: { name: "Randall W. Franz, MD", athenaProviderId: "163", credential: "MD", departmentId: "237" },
  HISLOP: { name: "Sean J. Hislop, MD", athenaProviderId: "164", credential: "MD", departmentId: "238" },
  HOCHBERG: { name: "Kristian O. Hochberg, MD", athenaProviderId: "165", credential: "MD", departmentId: "236" },
  KEEFER: { name: "Adam J. Keefer, MD", athenaProviderId: "166", credential: "MD", departmentId: "239" },
  // Floats across all locations, unlike the other MDs above who are each tied to a home department.
  JAECKLIN: { name: "Frederick Jaecklin, MD", athenaProviderId: "183", credential: "MD", departmentId: null },
  CHARGUALAF: { name: "Mark Chargualaf, PA-C", athenaProviderId: "185", credential: "PA-C", departmentId: null },
  GREENWOOD: {
    name: "Jesse (Jessica Marie) Greenwood, PA-C",
    athenaProviderId: "188",
    credential: "PA-C",
    departmentId: null,
  },
  PECK: { name: "Victoria Peck, PA-C", athenaProviderId: "169", credential: "PA-C", departmentId: null },
  HERR: { name: "Holly Petrusson Herr, PA-C", athenaProviderId: "167", credential: "PA-C", departmentId: null },
} as const satisfies Record<string, CvvcProviderRosterEntry>;
